<template>
	<div></div>
</template>

<script>
	import {cryptoJs} from '@deanwu/vue-component-library'

	export default {
		props: {
			url: String
		},

		mounted() {
			if (!this.url) {
				this.redirectTo('/');
				return;
			}

			let instance;
			!function loop(data) {
				setTimeout(() => {
					if (!data || new Date().getTime() - data.time >= 50 * 60 * 1000) {
						this.request({
							url: data ? '/oss/weboffice/token/refresh' : '/oss/weboffice/token/get',
							data: data ? {
								accessToken: data.accessToken,
								refreshToken: data.refreshToken
							} : {
								filepath: cryptoJs.AES.decrypt(decodeURIComponent(this.url), 'doc').toString(cryptoJs.enc.Utf8)
							},
							success: data => {
								if (!instance) {
									instance = aliyun.config({
										url: data.webofficeURL
									});
								}
								data.time = new Date().getTime();
								instance.setToken({
									token: data.accessToken,
									timeout: 60 * 60 * 1000 
								});
								loop.call(this, data);
							}
						})
					} else {
						loop.call(this, data);
					}
				}, data ? 60000 : 0)
			}.call(this);
		}
	}
</script>